export default "__VITE_ASSET__8e2e32e3__"